import { useTranslation } from 'react-i18next';

import {
    Avatar,
    Body1,
    Body2,
    Box,
    Flex,
    IconButton,
    IconMoreVert,
} from '@myphx-engineering/phx-design-system';
import { getInitials } from '@myphx-engineering/phx-design-system/framework';

import type { IndividualCareRecipient } from '../../../graphql/generated/graphql';

export type CareRecipientProps = {
    member: IndividualCareRecipient;
};

export const CareRecipient = ({ member }: CareRecipientProps) => {
    const { t } = useTranslation();

    return (
        <Flex gap="xs">
            <Avatar initials={getInitials(member.name)} />
            <Box flex={1}>
                <Body1 bold>{member.name}</Body1>
                <Body2>
                    {member.fullAccess
                        ? t('careCircle.access.full')
                        : t('careCircle.access.limited')}
                </Body2>
            </Box>
            <IconButton size="sm" color="gray" Icon={IconMoreVert} />
        </Flex>
    );
};
